/**
 * Part of ankecare project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */
import '@main';

$('.c-article').find('iframe, object, embed').parent().addClass('rwd-video');

$(document).ready(function () {
  const wrapper = document.querySelector('.j-wrapper');
  const audio = document.querySelector('#article-audio');
  const timeText = document.querySelector('.j-audio-time');
  const playBtn = document.querySelector('.j-audio-play');
  const pauseBtn = document.querySelector('.j-audio-pause');

  window.setTimeout(() => {
    timeText.textContent = formatTime(audio.duration);
    wrapper.classList.add('show');
  }, 800);

  playBtn.addEventListener('click', function (e) {
    audio.play();

    e.currentTarget.classList.add('d-none');

    pauseBtn.classList.remove('d-none');
  });

  pauseBtn.addEventListener('click', function (e) {
    audio.pause();

    e.currentTarget.classList.add('d-none');

    playBtn.classList.remove('d-none');
  });

  audio.addEventListener('timeupdate', () => {
    timeText.textContent = formatTime(audio.duration - audio.currentTime);
  });

  audio.addEventListener('ended', () => {
    audio.currentTime = 0;
    timeText.textContent = formatTime(audio.duration);

    playBtn.classList.remove('d-none');
    pauseBtn.classList.add('d-none');
  });
});

function formatTime(seconds) {
  let min = Math.floor(seconds / 60);
  let sec = Math.floor(seconds % 60);
  return `${min}:${sec < 10 ? '0' : ''}${sec}`;
}
